import classnames from 'classnames'
import sumBy from 'lodash/sumBy'
import moment from 'moment'
import React from 'react'
import { i18n } from '../index'
import type { BudgetPlanItem, ForecastSalesItem, PlanItem } from './types'

import css from './BudgetTable.css'

type Props = {
  week: number
  budgetData: Array<BudgetPlanItem>
  forecastData: Array<ForecastSalesItem>
  planData: Array<PlanItem>
  targetEfficiency: number
  isStationPage: boolean
}

const WeekRow = ({ week, budgetData, forecastData, planData, targetEfficiency, isStationPage }: Props) => {
  const filteredBudgetData = budgetData.filter((item) => moment(item.date).week() === week)
  const filteredForecastData = forecastData.filter((item) => moment(item.date).week() === week)
  const filteredPlanData = planData.filter((item) => moment(item.date).week() === week)

  const budgetedSales = sumBy(filteredBudgetData, 'budgetedSales')
  const budgetedHours = sumBy(filteredBudgetData, 'budgetedHours')
  const forecastSales = sumBy(filteredForecastData, 'sales')
  const plannedSales = sumBy(filteredPlanData, 'plannedSales')
  const plannedHours = sumBy(filteredPlanData, 'plannedHours')

  const efficiency = plannedHours ? plannedSales / plannedHours : 0

  return (
    <tr className={css.weekRow}>
      <td>
        {i18n.t('common.weekShort')} {week}
      </td>
      <td>{budgetedSales.toFixed(0)}</td>
      <td>{budgetedHours.toFixed(0)}</td>
      {isStationPage && <td>{forecastSales.toFixed(0)}</td>}
      <td>{plannedSales.toFixed(0)}</td>
      <td>{plannedHours.toFixed(0)}</td>
      <td
        className={classnames(css.efficiency, {
          [css.overTarget]: efficiency > targetEfficiency,
        })}
      >
        {efficiency.toFixed(0)}
      </td>
      <td />
    </tr>
  )
}

export default WeekRow
